// import logoImg from "/images/logos/logoImg.svg";
// import logoTextImg from "/images/logos/logoText.svg";
import Image from "next/image";
import logo from "@/public/images/logo.svg";
import MyLink from "@/components/shared/myLink/MyLink";

function Logo() {
  return (
    <div className="sticky start-0 top-0 z-20 flex h-[70px] w-full items-center border-b border-slate-100 bg-white/95 px-5 backdrop-blur">
      <MyLink
        href="/dashboard"
        aria-label="لوحة تحكم سفير الجامعات"
        className="flex w-fit items-center"
      >
        <Image
          src={logo}
          alt="سفير الجامعات"
          width={112}
          height={44}
          priority
          className="h-auto w-[112px] object-contain"
        />
      </MyLink>
    </div>
  );
}

export default Logo;
